import "./MpfButton.scss"

export type MpfButtonVariant =
    | "primary"
    | "secondary"
    | "reverse"
    | "warning"
    | "login"
    | "secondary-solid";

export interface MpfButtonProps {
    label: string;
    variant?: MpfButtonVariant;
    disabled?: boolean;
    preventDoubleClick?: boolean;
}
export const mpfButtonDefaults =
    {
        variant: "primary",
        disabled: false,
    } satisfies Partial<MpfButtonProps>;
